{
  "sidebar": {
    "dashboard": "Dashboard",
    "titles": "Titles",
    "services": "Services",
    "billing": "Billing",
    "publishers": "Publishers",
    "enterprise": "Enterprise",
    "settings": "Settings",
    "profile": "Profile",
    "signOut": "Sign out",
    "notifications": "Notifications",
    "publishing": "Publishing",
    "management": "Management",
    "sectionDashboard": "Dashboard",
    "publisherPanel": "Publisher Panel",
    "adminPanel": "Admin Panel",
    "legal": "Legal",
    "pinSidebar": "Pin sidebar",
    "unpinSidebar": "Unpin sidebar",
    "language": "English",
    "mobileNav": "Navigation",
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "account": "Account",
    "home": "Home"
  },
  "themeToggle": {
    "label": "Toggle theme"
  },
  "nav": {
    "dashboard": "Dashboard",
    "titles": "Titles",
    "files": "Files",
    "settings": "Settings",
    "logout": "Logout",
    "admin": "Admin"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "loading": "Loading...",
    "error": "An error occurred",
    "success": "Success",
    "confirm": "Confirm",
    "search": "Search",
    "all": "All",
    "noResults": "No results found",
    "actions": "Actions",
    "imageBroken": "Broken",
    "errors": {
      "notFound": "Page Not Found",
      "notFoundDescription": "The page you're looking for doesn't exist or was moved.",
      "serverError": "Server Error",
      "serverErrorDescription": "Something went wrong on our end. Please try again later.",
      "requestFailed": "Request Failed",
      "requestFailedDescription": "We couldn't complete your request. Please try again.",
      "goToDashboard": "Go to Dashboard",
      "backToLogin": "Back to Sign In",
      "generic": "Something went wrong. Please try again.",
      "validation": "Please correct the highlighted fields."
    }
  },
  "status": {
    "approved": "Approved",
    "pending": "Pending",
    "suspended": "Suspended",
    "editing": "Editing"
  },
  "roles": {
    "admin": "Admin",
    "publisher": "Publisher"
  },
  "brandName": "Ur-Nammu Publishing",
  "brandNameShort": "Ur-Nammu",
  "copyright": "© {{year}} UR-NAMMU PUBLISHING LTD",
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark all read",
    "viewAll": "View all notifications",
    "emptyTitle": "No notifications yet",
    "emptyDesc": "You're all caught up. New activity will appear here.",
    "loadError": "Failed to load notifications."
  },
  "pageTitles": {
    "login": "Ur-Nammu Publishing | Sign In",
    "register": "Ur-Nammu Publishing | Create Account",
    "forgotPassword": "Ur-Nammu Publishing | Reset Password",
    "resetPassword": "Ur-Nammu Publishing | Set New Password",
    "verifyEmail": "Ur-Nammu Publishing | Verify Email",
    "dashboard": "Ur-Nammu Publishing | Dashboard",
    "adminDashboard": "Ur-Nammu Publishing | Admin Dashboard"
  },
  "dashboard": {
    "eyebrow": "Publisher Portal",
    "greeting": {
      "morning": "Good morning, {{name}}.",
      "afternoon": "Good afternoon, {{name}}.",
      "evening": "Good evening, {{name}}."
    },
    "submitTitle": "Submit New Title",
    "viewAll": "View all {{n}}",
    "kpi": {
      "totalTitles": "Total titles"
    },
    "breakdown": {
      "byStatus": "Titles by status"
    },
    "quota": {
      "title": "Plan usage",
      "label": "Titles used",
      "remaining": "{{n}} of {{limit}} remaining",
      "unlimited": "Unlimited"
    },
    "subscription": {
      "title": "Subscription",
      "expires": "Renews {{date}}",
      "noExpiry": "No renewal date",
      "none": "No active plan",
      "subscribe": "Subscribe",
      "status": {
        "active": "Active",
        "trialing": "Trial",
        "past_due": "Past due",
        "canceled": "Canceled",
        "incomplete": "Incomplete",
        "incomplete_expired": "Expired",
        "unpaid": "Unpaid",
        "paused": "Paused"
      }
    },
    "plan": {
      "none": "No plan"
    },
    "activity": {
      "title": "Recent activity",
      "kind": {
        "titleSubmitted": "Title submitted",
        "titleApproved": "Title approved",
        "titleSuspended": "Title suspended",
        "revisionSubmitted": "Revision submitted",
        "revisionApproved": "Revision approved",
        "revisionRejected": "Revision rejected"
      },
      "relative": {
        "now": "just now",
        "minutes": "{{n}}m ago",
        "hours": "{{n}}h ago",
        "days": "{{n}}d ago"
      }
    },
    "recentSubmissions": "Recent Submissions",
    "fields": {
      "title": "Title",
      "status": "Status",
      "submitted": "Submitted"
    }
  },
  "settings": {
    "sectionLabel": "Account & Preferences",
    "pageTitle": "Settings",
    "pageSubtitle": "Manage your notification, language, and display preferences",
    "notifications": {
      "sectionTitle": "Notifications",
      "webPush": {
        "label": "Web Push",
        "description": "Browser push notifications"
      },
      "emailPush": {
        "label": "Email",
        "description": "Email-based notifications"
      },
      "testPush": "Test Push",
      "testPushDone": "Sent!",
      "testEmail": "Test Email",
      "testEmailDone": "Sent!",
      "statusDenied": "Blocked — reset via address bar 🔒 icon"
    },
    "language": {
      "sectionTitle": "Language",
      "rowLabel": "Language",
      "arAbbr": "Arabic",
      "enAbbr": "English",
      "arCurrent": "Arabic (current)",
      "enCurrent": "English (current)"
    },
    "appearance": {
      "sectionTitle": "Appearance",
      "rowLabel": "Appearance",
      "lightDescription": "Light mode",
      "darkDescription": "Dark mode",
      "systemDescription": "Follow system",
      "light": "Light",
      "dark": "Dark",
      "system": "System"
    }
  },
  "close": "Close",
  "expand": "Expand",
  "publisher": "Publisher",
  "title": "Title",
  "avatar": {
    "uploadPhoto": "Upload photo",
    "changePhoto": "Change photo",
    "uploadError": "Failed to upload photo",
    "fileTooLarge": "File size exceeds the limit",
    "invalidType": "File type not supported",
    "photoAlt": "Profile photo of {{name}}"
  },
  "login": {
    "tagline": "The advanced publishing portal",
    "registeredSuccess": "Account created. Sign in now.",
    "verifiedSuccess": "Email verified. Sign in.",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "errors": {
      "emailRequired": "Email is required",
      "passwordRequired": "Password is required",
      "invalidCredentials": "Invalid credentials"
    }
  },
  "errors": {
    "generic": "An error occurred. Please try again."
  },
  "revision": {
    "tags": {
      "added": "Added",
      "changed": "Changed",
      "removed": "Removed"
    },
    "needsAttention": "needs attention",
    "validated": "Validated",
    "invalid": "Validation failed",
    "was": "Was",
    "now": "Now",
    "current": "Current",
    "proposed": "Proposed",
    "fieldsChanged": "fields changed",
    "filesReplaced": "files replaced",
    "changes": "changes",
    "files": "files"
  },
  "readOnly": {
    "banner": "Your subscription has ended — read-only access",
    "resubscribe": "Resubscribe",
    "disabledHint": "Resubscribe to use this action"
  }
}